import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const PhoneButton = styled('div')({
  borderRadius: '5px',
  backgroundColor: 'black',
  position: 'absolute',
});

export type DemoProps = {
  content?: string;
  onClick?: () => void;
};

const Demo = ({ content, onClick }: DemoProps) => {
  return (
    <Box sx={{ position: 'relative', maxWidth: '550px', width: '90%' }}>
      <Box sx={{ display: 'flex', position: 'relative', height: '100%', width: '100%' }}>
        <PhoneButton sx={{ width: '9.6%', height: '3%', top: '-1.5%', right: '30%' }} />
        <PhoneButton sx={{ width: '9.6%', height: '3%', top: '-1.5%', right: '20%' }} />
        <PhoneButton sx={{ width: '4.8%', height: '3%', top: '-1.5%', right: '12%' }} />
        <PhoneButton sx={{ width: '12.8%', height: '3%', bottom: '-1%', right: '25%' }} />

        <Box
          sx={{
            display: 'flex',
            borderRadius: '35px',
            border: '10px solid black',
            overflow: 'hidden',
            width: '100%',
            pb: '58%',
            position: 'relative',
          }}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              display: 'flex',
              cursor: 'pointer',
            }}>
            <img onClick={onClick} src={content} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Demo;
